export const objectCopy = function(_object) {
    return JSON.parse(JSON.stringify(_object));
}


export const str_gb_len = function(str){
    var len = 0;
    for (var i=0; i<str.length; i++) { 
        var c = str.charCodeAt(i); 
        //单字节加1 
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) { 
            len+=8;
        } 
        else { 
            len+=14; 
        } 
    } 
    return len;
}


// WEBPACK FOOTER //
// ./src/utils/util.js